'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _rollupPluginBabelHelpers = require('../../../../_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');
var React__default = _interopDefault(React);
var PropTypes = _interopDefault(require('prop-types'));
var Link = require('../../00.helper/Link/Link.js');
var classNames = _interopDefault(require('classnames/dedupe'));
var Icon = require('../../01.atoms/Icon/Icon.js');
var Avatar = require('../../01.atoms/Avatar/Avatar.js');
var MaterialDrop = require('../../01.atoms/MaterialDrop/MaterialDrop.js');
var Modal = require('../Modal/Modal.js');
var Tooltip = require('../Tooltip/Tooltip.js');
require('./_index.scss.js');

var CLASSNAME = 'varta-user-item',
    cnWrapper = "".concat(CLASSNAME, "__wrapper"),
    cnUsername = "".concat(CLASSNAME, "__username"),
    cnWrapperTooltip = "".concat(CLASSNAME, "__wrapper-tooltip"),
    cnAvatar = "".concat(CLASSNAME, "__avatar"),
    cnLabel = "".concat(CLASSNAME, "__label"),
    cnName = "".concat(CLASSNAME, "__name"),
    cnClearSession = "".concat(CLASSNAME, "__clear-session"),
    cnClear = "".concat(CLASSNAME, "__clear"),
    cnModal = "".concat(CLASSNAME, "__modal"),
    cnModalContent = "".concat(CLASSNAME, "__modal-content"),
    cnModalUsers = "".concat(cnModal, "__users"),
    cnModalRow = "".concat(cnModal, "__row"),
    cnModalLabel = "".concat(cnModal, "__label");
var USER_LIMIT = 3;
/**
 * 
 */

var UserItem = /*#__PURE__*/function (_React$Component) {
  _rollupPluginBabelHelpers.inherits(UserItem, _React$Component);

  var _super = _rollupPluginBabelHelpers.createSuper(UserItem);

  function UserItem() {
    var _this;

    _rollupPluginBabelHelpers.classCallCheck(this, UserItem);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _rollupPluginBabelHelpers.defineProperty(_rollupPluginBabelHelpers.assertThisInitialized(_this), "ref", /*#__PURE__*/React__default.createRef());

    _rollupPluginBabelHelpers.defineProperty(_rollupPluginBabelHelpers.assertThisInitialized(_this), "state", {});

    _rollupPluginBabelHelpers.defineProperty(_rollupPluginBabelHelpers.assertThisInitialized(_this), "onClickOutside", function (e) {
      var target = e.target;

      if (_this.ref.current && !_this.ref.current.contains(target)) {
        _this.setState({
          open: false
        });
      }
    });

    return _this;
  }

  _rollupPluginBabelHelpers.createClass(UserItem, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener('click', this.onClickOutside);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('click', this.onClickOutside);
    }
  }, {
    key: "expandItems",
    value: function expandItems() {
      var _this2 = this;

      var _this$props = this.props,
          items = _this$props.items,
          users = _this$props.users,
          onShowAll = _this$props.onShowAll,
          onLoginMore = _this$props.onLoginMore,
          i18n = _this$props.i18n;
      return [].concat(_rollupPluginBabelHelpers.toConsumableArray(items), [// inherit Tooltip properties
      [function (props) {
        return /*#__PURE__*/React__default.createElement("div", {
          key: "users"
        }, !!users.length && /*#__PURE__*/React__default.createElement("span", {
          className: cnLabel
        }, i18n.changeUser), _this2.renderUserItems(USER_LIMIT, props));
      }].concat(_rollupPluginBabelHelpers.toConsumableArray(users.length > USER_LIMIT ? [{
        title: i18n.showAll,
        badge: users.length,
        onClick: function onClick(e) {
          e.preventDefault();

          _this2.setState({
            open: false,
            showMore: true
          });

          onShowAll(e);
        }
      }] : []), [{
        title: i18n.loginMore,
        onClick: function onClick(e) {
          _this2.setState({
            open: false
          });

          onLoginMore(e);
        }
      }])]);
    }
  }, {
    key: "renderUserItems",
    value: function renderUserItems(limit) {
      var _this3 = this;

      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          cnGroup = _ref.cnGroup,
          cnLink = _ref.cnLink,
          cnl = _ref.cnLabel,
          _ref$avatarSize = _ref.avatarSize,
          avatarSize = _ref$avatarSize === void 0 ? 'xs' : _ref$avatarSize;

      var _this$props2 = this.props,
          users = _this$props2.users,
          onUserClick = _this$props2.onUserClick,
          onForgetLogin = _this$props2.onForgetLogin;

      if (!users) {
        return null;
      }

      return /*#__PURE__*/React__default.createElement("ul", {
        className: classNames(cnGroup)
      }, (limit ? users.slice(0, limit) : users).map(function (user) {
        return /*#__PURE__*/React__default.createElement("li", {
          key: user.id,
          className: cnLink,
          onClick: function onClick(e) {
            onUserClick(e, user);

            _this3.setState({
              open: false,
              showMore: false
            });
          }
        }, /*#__PURE__*/React__default.createElement(Avatar, _rollupPluginBabelHelpers.extends({}, user, {
          size: avatarSize,
          className: cnAvatar
        })), /*#__PURE__*/React__default.createElement("span", {
          className: classNames(cnl, cnName)
        }, "".concat(user.firstName || '').concat(user.firstName && user.lastName ? ' ' : '').concat(user.lastName || '')), !user.token && !user.isProfile && /*#__PURE__*/React__default.createElement("button", {
          className: cnClearSession,
          title: "Forget Login",
          onClick: function onClick(e) {
            e.preventDefault();
            e.stopPropagation();
            onForgetLogin(user.id);
          }
        }, /*#__PURE__*/React__default.createElement(Icon, {
          size: "xxs",
          id: "cancel-light",
          className: cnClear
        })));
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var _this$props3 = this.props,
          items = _this$props3.items,
          profile = _this$props3.profile,
          link = _this$props3.link,
          i18n = _this$props3.i18n,
          onOpen = _this$props3.onOpen,
          _this$state = this.state,
          open = _this$state.open,
          showMore = _this$state.showMore;
      var LinkElement = link ? Link : 'span';
      var ClickElement = link ? 'a' : 'div';
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(LinkElement, link, /*#__PURE__*/React__default.createElement(ClickElement, {
        className: CLASSNAME,
        onClick: function onClick(e) {
          if (items.length) {
            e.preventDefault();

            _this4.setState(function (_ref2) {
              var o = _ref2.open;

              if (!open && !o) {
                onOpen();
              }

              return {
                open: !o
              };
            });
          }
        },
        ref: this.ref,
        "data-type": "header",
        "data-function": "tooltip"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: cnWrapper
      }, /*#__PURE__*/React__default.createElement(Avatar, _rollupPluginBabelHelpers.extends({
        className: cnAvatar,
        size: "xs"
      }, profile)), /*#__PURE__*/React__default.createElement("span", {
        className: cnUsername
      }, profile ? profile.firstName : i18n.login)), /*#__PURE__*/React__default.createElement("div", {
        className: cnWrapperTooltip
      }, open && /*#__PURE__*/React__default.createElement(Tooltip, {
        items: this.expandItems()
      })), /*#__PURE__*/React__default.createElement(MaterialDrop, null))), /*#__PURE__*/React__default.createElement(Modal, {
        open: showMore,
        onClose: function onClose() {
          return _this4.setState({
            showMore: false
          });
        },
        className: cnModal,
        classNameContent: cnModalContent,
        title: i18n.labelModal,
        showCloseButton: true,
        noPadding: true
      }, this.renderUserItems(0, {
        cnGroup: cnModalUsers,
        cnLink: cnModalRow,
        cnLabel: cnModalLabel,
        avatarSize: 'sm'
      })));
    }
  }]);

  return UserItem;
}(React__default.Component);
UserItem.propTypes = {
  /** Translation object */
  i18n: PropTypes.shape({
    changeUser: PropTypes.string.isRequired,
    showAll: PropTypes.string.isRequired,
    login: PropTypes.string.isRequired,
    loginMore: PropTypes.string.isRequired,
    labelModal: PropTypes.string.isRequired
  }).isRequired,

  /** Array of items */
  items: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string.isRequired,
    badge: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    onClick: PropTypes.func
  }))),

  /** URL to link to */
  link: PropTypes.string,

  /** Callback function on pw forget */
  onForgetLogin: PropTypes.func,

  /** Callback function on login more */
  onLoginMore: PropTypes.func,

  /** Callback function on open dropdown*/
  onOpen: PropTypes.func,

  /** Callback function show all clicked */
  onShowAll: PropTypes.func,

  /** Callback function single user clicked */
  onUserClick: PropTypes.func,

  /** Profile object */
  profile: PropTypes.shape(),

  /** Array of user objects */
  users: PropTypes.arrayOf(PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    id: PropTypes.string.isRequired,
    image: PropTypes.string
  }))
};
UserItem.defaultProps = {
  items: [],
  users: [],
  onShowAll: function onShowAll() {
    return void 0;
  },
  onLoginMore: function onLoginMore() {
    return void 0;
  },
  onOpen: function onOpen() {
    return void 0;
  },
  onUserClick: function onUserClick() {
    return void 0;
  },
  onForgetLogin: function onForgetLogin() {
    return void 0;
  }
};

module.exports = UserItem;
